import angular from 'angular'

import { profileRoutes } from './profile.routes'
import { businessDataService } from './services/business-data.service'
import { contextService } from './services/context.service'
import { userService } from './services/user.service'

const module = angular
  .module('deskfy.profile', [])
  .config(profileRoutes)
  .factory('BusinessDataService', businessDataService)
  .factory('ContextService', contextService)
  .factory('UserService', userService)

export const profileModule = module
